import React from 'react';
import { Button } from 'antd';
import { useMsal } from '@azure/msal-react';
import { LoginOutlined } from '@ant-design/icons';
import { loginRequest } from '../config/authConfig';

interface LoginButtonProps {
  size?: 'small' | 'middle' | 'large';
  type?: 'primary' | 'default' | 'dashed' | 'link' | 'text';
}

const LoginButton: React.FC<LoginButtonProps> = ({ size = 'middle', type = 'primary' }) => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginPopup(loginRequest).catch(e => {
      console.error('Login failed:', e);
    });
  };

  return (
    <Button
      type={type}
      size={size}
      icon={<LoginOutlined />}
      onClick={handleLogin}
    >
      Sign In with Microsoft
    </Button>
  );
};

export default LoginButton;